<!---design on mobile will be changed-->
<template>
    <div class="table">
    <table>
        <tr>
            <th scope="row">Project number</th>
            <td>{{number}}</td>
        </tr>
        <tr>
            <th scope="row">Project description</th>
            <td>{{desc}}</td>
        </tr>
        <tr>
            <th scope="row">Quota</th>
            <td>{{quota}}</td>
        </tr>
        <tr>
            <th scope="row">Usage</th>
            <td>{{usage}}</td>
        </tr>
    </table>
    <button class="unstyled-button row-button" @click="handleClick">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="20" width="20" fill="#051C2E">
            <path d="M8.025 21.65 6.6 20.225 14.825 12 6.6 3.775 8.025 2.35l9.65 9.65Z"/>
        </svg>
    </button>
    </div>
</template>

<script>
export default {
    name: "ProjectTableMobile",
    props: {
        number: String,
        desc: String,
        quota: Number,
        usage: Number
    },
    methods: {
        handleClick() {
            this.$emit('project-clicked', this.number);
        }
    }
}
</script>

<style scoped>

.table {
    display: flex;
    flex-direction: row;
}

.row-button {
    cursor: pointer;
    border: 1px solid var(--blue-gray);
    margin-bottom: 1.5rem;
    box-shadow: -2px 0px 10px -3px var(--shadow)
}

table {
    border: 1px solid var(--blue-gray);
    border-right: none;
}

tr {
    display: flex;
    flex-direction: column;
}

th {
    padding-bottom: 0.3rem;
}

td {
    padding-top: 0;
}
</style>